import { useEffect } from "react";

export default function Privacy() {
  useEffect(() => { document.title = "Privacy Policy — Scott Burton Photography"; }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-28 pb-24" data-testid="privacy-page">
      <div className="overline-label mb-3">Legal</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Privacy Policy</h1>
      <p className="mt-4 text-neutral-500 text-sm">Last updated {new Date().getFullYear()}</p>

      <div className="mt-10 space-y-8 text-neutral-300 leading-relaxed text-sm">
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">What we collect</h2>
          <p>When you place a print or licensing order we collect the details you provide — your name, email, shipping address and order contents. Payment card details are entered directly with our payment processor (Stripe) and are never stored on our servers.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">How we use it</h2>
          <p>We use your information only to process and fulfil your order, send order confirmations and shipping updates, respond to your enquiries, and meet our legal obligations. We do not sell your personal information.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Who we share it with</h2>
          <p>To fulfil prints we share your shipping details with our print lab, Miller's Professional Imaging. We use Stripe to process payments and an email provider to send confirmations. Each processes your data only to provide their service.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Cookies &amp; analytics</h2>
          <p>This site uses privacy-respecting analytics to understand how visitors use the gallery so we can improve it. No advertising trackers are used.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Your rights &amp; contact</h2>
          <p>You may request a copy or deletion of your personal data at any time. Use the <a className="text-amber-glow" href="/contact">contact form</a> or call 662.801.3526.</p>
        </section>
      </div>
    </div>
  );
}
